import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing-models-create',
  imports: [],
  templateUrl: './pricing-models-create.html',
  styleUrl: './pricing-models-create.scss',
})
export class PricingModelsCreate {

}
